module.exports = __webpack_public_path__ + "img/bg-main_2x.a6d2975.jpg";